import React, { useState } from 'react';
import { documentsTableColumns } from 'modules/customers/constants';
import { FormInput } from 'components/form';
import { MUITable } from 'components/shared/MUITable';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import makeStyles from '@mui/styles/makeStyles';
import { Box, InputAdornment } from '@mui/material';
import { DocumentsTableRow } from 'modules/customers/types';
import { Search } from '@mui/icons-material';
import { filterTableBySerachTerm } from 'modules/customers/lib';

interface Props {
  documentsTableData: DocumentsTableRow[];
}

export const DocumentsCard = ({ documentsTableData }: Props) => {
  const classes = useStyles();

  const [searchValue, setSearchValue] = useState<string>();
  const [tableDataToShow, setTableDataToShow] = useState(documentsTableData);

  const handleSearchTermChange = (searchValue: string) => {
    setSearchValue(searchValue);
    if (!searchValue || searchValue.length < 3) {
      return setTableDataToShow(documentsTableData);
    }
    const keysToFilter = ['docName', 'taskRegrading', 'docType', 'docDescription'];
    const filteredData = filterTableBySerachTerm(documentsTableData, searchValue, keysToFilter);
    setTableDataToShow(filteredData);
  };

  return (
    <CardContainer title="Documents">
      <FormInput
        label="Search"
        variant="outlined"
        value={searchValue}
        sx={{ maxWidth: '50%' }}
        onChange={handleSearchTermChange}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          },
        }}
      />
      <Box className={classes.table}>
        <MUITable<DocumentsTableRow> columns={documentsTableColumns} tableData={tableDataToShow} isLoading={false} />
      </Box>
    </CardContainer>
  );
};

const useStyles = makeStyles({
  table: {},
});
